__turbopack_context__.v({
  "action-container": "Referral-module-scss-module__tl3KlW__action-container",
  "action-description": "Referral-module-scss-module__tl3KlW__action-description",
  "action-media": "Referral-module-scss-module__tl3KlW__action-media",
  "merch-card": "Referral-module-scss-module__tl3KlW__merch-card",
  "tag-link": "Referral-module-scss-module__tl3KlW__tag-link",
});
